<script setup>
import { FORM_FIELD_VALUE_TYPES } from '@/constants'
import FormFieldInput from '@/components/FormFieldInput.vue'
import FormFieldNumber from '@/components/FormFieldNumber.vue'
import FormFieldTags from '@/components/FormFieldTags.vue'

defineProps({
  valueType: {
    type: String,
    default: 'string'
  },
  fieldModel: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <!-- String List Input -->
  <div v-if="valueType === FORM_FIELD_VALUE_TYPES.STRING_LIST">
    <FormFieldTags
      class="form-control"
      placeholder="Add a tag..."
      :fieldModel="fieldModel"
      :disabled="disabled"
    />
  </div>
  <!-- Currency Input -->
  <div
    class="input-group"
    v-else-if="valueType === FORM_FIELD_VALUE_TYPES.CURRENCY"
  >
    <span class="input-group-text">$</span>
    <FormFieldNumber
      class="form-control"
      :fieldModel="fieldModel"
      :disabled="disabled"
    />
  </div>
  <!-- Days Input -->
  <div
    class="input-group"
    v-else-if="valueType === FORM_FIELD_VALUE_TYPES.DAYS"
  >
    <FormFieldNumber
      class="form-control"
      :fieldModel="fieldModel"
      :disabled="disabled"
    />
    <span class="input-group-text">days</span>
  </div>
  <!-- Free Text Input -->
  <FormFieldInput
    v-else
    type="text"
    class="form-control"
    :fieldModel="fieldModel"
    :disabled="disabled || !valueType"
  />
</template>
